import { render, staticRenderFns } from "./StockInStatsCard.vue?vue&type=template&id=60ad93e6"
import script from "./StockInStatsCard.vue?vue&type=script&lang=js"
export * from "./StockInStatsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports